import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { decryptId } from '../utils/urlEncryption';
import CreateOrderStepper from './CreateOrderStepper';

const EditOrder = ({ user, onLogout }) => {
  const { orderId: encryptedOrderId } = useParams();
  const navigate = useNavigate();
  
  // Decrypt the order ID from URL
  const orderId = decryptId(encryptedOrderId);
  
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrderData();
  }, [orderId]);

  const loadOrderData = async () => {
    try {
      const res = await axiosInstance.get(`/orders/${orderId}`);
      setOrderData(res.data);
    } catch (err) {
      toast.error('Failed to load order data');
      navigate('/orders');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-amber-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading order...</p>
        </div>
      </div>
    );
  }

  if (!orderData) {
    return null;
  }

  return (
    <CreateOrderStepper 
      user={user} 
      onLogout={onLogout} 
      editMode={true}
      existingOrder={orderData}
    />
  );
};

export default EditOrder;
